import { PatientGuarantor } from "pwapi";

import { shallowLeftDiff } from "shared/utils/formUtils";
import { checkGuarantorAddress } from "shared/utils/patientUtils";

export const initialValuesForPatientGuarantor = (
  guarantor: PatientGuarantor
): PatientGuarantor => {
  return {
    ...guarantor,
    relationship_to_patient:
      guarantor.relationship_to_patient === "SEL"
        ? "SELF"
        : guarantor.relationship_to_patient || undefined,
    address: guarantor.address,
  };
};

export const submissionFieldsForPatientGuarantor = (
  guarantor: PatientGuarantor,
  values?: Partial<PatientGuarantor>
) => {
  if (!values) values = initialValuesForPatientGuarantor(guarantor);
  const address = checkGuarantorAddress(values.address);
  return values.relationship_to_patient === "SELF"
    ? { relationship_to_patient: "SELF" }
    : {
        first_name: values.first_name || null,
        middle_initial: values.middle_initial || null,
        last_name: values.last_name || null,
        sex: values.sex || null,
        date_of_birth: values.date_of_birth || null,
        ssn: values.ssn || null,
        relationship_to_patient: values.relationship_to_patient || null,

        address: address
          ? {
              street: address.street || null,
              street2: address.street2 || null,
              zipcode: address.zipcode || null,
              phone1: address.phone1 || null,
              phone2: address.phone2 || null,
              state: address.state || null,
              city: address.city || null,

              id: guarantor.address?.id,
            }
          : undefined,
      };
};

export const shallowPatientGuarantorComparison = (
  guarantor: PatientGuarantor,
  values: PatientGuarantor
) => {
  const oldValues = submissionFieldsForPatientGuarantor(guarantor);
  const newValues = submissionFieldsForPatientGuarantor(guarantor, values);

  return shallowLeftDiff<
    ReturnType<typeof submissionFieldsForPatientGuarantor>
  >(oldValues, newValues);
};
